var Student = "Estudante";
var jobRole = {
	"Job role": "Função",
	"Academic / Researcher": "Acadêmico/Pesquisa",
	"Advisor / Consultant": "Orientação/Consultoria",
	"Business Executive": "Executivo de negócios",
	"Developer / Engineer": "Desenvolvedor/Engenheiro",
	"Entrepreneur (Founder/Co-Founder)": "Empreendedor (Fundador/Cofundador)",
	"IT Executive": "Executivo de TI",
	"IT Professional or Technical Manager": "Gerente técnico ou profissional de TI",
	"Press / Media Analyst": "Imprensa/Analista de mídia",
	"Sales / Marketing": "Vendas/Marketing",
	Student: Student,
	"Solution or Systems Architect": "Arquiteto de soluções ou sistemas",
	"System Administrator": "Administrador de sistemas",
	"Venture Capitalist": "Investidor"
};

export { Student, jobRole as default };
